import { applyMiddleware, createStore } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
// import axios from "axios";
import promise from "redux-promise-middleware";

import reducer from "./../reducers";

// const middleware = applyMiddleware(promise(), thunk, logger());
const middleware = applyMiddleware(promise(), thunk);
export default createStore(reducer, middleware);



// WEBPACK FOOTER //
// ./src/store/store.js